import HelpViewCategory from '../../components/Help/HelpViewCategory';
import PageMain from '../../components/Navigation/PageMain/PageMain';

export default function HelpCategoryPage() {
    return (
        <PageMain pageTitle="Category" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <HelpViewCategory />
                </div>
            </div>
        </PageMain>
    );
}
